// Runtime re-export from vendored source (patched readTags in dom.js)
// Types are provided by index.d.ts (no declare global leak)
export {
  BuyerIntentSessionElement,
  BuyerIntentSubjectElement,
  BuyerIntentViewElement,
  BuyerIntentClickElement,
  createBuyerIntentSDK,
  ensureSDK,
  buyerIntent,
} from './src/browser/index.js';
